import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {P24RegistrationData} from "../../models/p24-registration-data.model";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {CommonUtils} from "../../utils/common";
import {AppStateService} from "../../providers/app-state.service";
import {P24RegistrationDataService} from "../../providers/p24-registration-data.service";
import {mobilePhoneNumberValidator} from "../../utils/form-validators";

@Component({
  selector: 'app-add-p24-registration-data',
  templateUrl: './add-p24-registration-data.component.html',
  styleUrls: ['./add-p24-registration-data.component.scss'],
})
export class AddP24RegistrationDataComponent  implements OnInit, OnDestroy {
  @Input() vetclicnicUUID: string;
  @Input() p24Registration: P24RegistrationData;
  @Output() p24RegistrationDataEventEmitter: EventEmitter<P24RegistrationData> = new EventEmitter<P24RegistrationData>();
  @Output() cancelEditp24Registration: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() hasUnsavedChangesEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  formGroup: FormGroup;
  actionBtnLabel: string = 'Dodaj dane rozliczeniowe';
  isBusy: boolean;
  isBusySub:Subscription;
  p24RegistrationDataSub:Subscription;
  hasUnsavedChanges: boolean;
  businessType: number;

  constructor(public  commonUtils: CommonUtils,
              private appStateService: AppStateService,
              private formBuilder: FormBuilder,
              private p24RegistrationDataService: P24RegistrationDataService
  ){ }

  ngOnInit() {
     this.appStateService.isBusySubject.subscribe(e=>this.isBusy=e);
     this.appStateService.updateIsBusySubject(true);
     if(this.p24Registration.uuid) {
       this.businessType = this.p24Registration.businessType;
       if (this.businessType == 1) {
         this.formGroup = this.formBuilder.group({
           bdName: [this.p24Registration.bdName, Validators.required],
           bdEmail: [this.p24Registration.bdEmail, [Validators.email, Validators.required]],
           invoiceEmail: [this.p24Registration.invoiceEmail, [Validators.email, Validators.required]],
           bankName: [this.p24Registration.bankName, Validators.required],
           bankAccount: [this.p24Registration.bankAccount, Validators.required],
           servicesDescription: [this.p24Registration.servicesDescription, Validators.required],
           bdPhone: [this.p24Registration.bdPhone, [Validators.required, mobilePhoneNumberValidator]],
           technicalPersonName: [this.p24Registration.technicalPersonName, Validators.required],
           technicalPersonEmail: [this.p24Registration.technicalPersonEmail, [Validators.email, Validators.required]],
           technicalPersonPhone: [this.p24Registration.technicalPersonPhone, [Validators.required, mobilePhoneNumberValidator]],
           contactPersonName: [this.p24Registration.contactPersonName, Validators.required],
           contactPersonEmail: [this.p24Registration.contactPersonEmail, [Validators.email, Validators.required]],
           contactPersonPhone: [this.p24Registration.contactPersonPhone, [Validators.required, mobilePhoneNumberValidator]],
           bdPostalCode: [this.p24Registration.bdPostalCode, Validators.required],
           bdCity: [this.p24Registration.bdCity, Validators.required],
           bdStreetWithNumber: [this.p24Registration.bdStreetWithNumber, Validators.required],
           correspondencePostalCode: [this.p24Registration.correspondencePostalCode, Validators.required],
           correspondenceCity: [this.p24Registration.correspondenceCity, Validators.required],
           correspondenceStreetWithNumber: [this.p24Registration.correspondenceStreetWithNumber, Validators.required],
           personalId: [this.p24Registration.personalId, Validators.required],
         });
         this.appStateService.updateIsBusySubject(false);
       } else {
         if (this.businessType > 3) {
           this.formGroup = this.formBuilder.group({
             bdName: [this.p24Registration.bdName, Validators.required],
             bdEmail: [this.p24Registration.bdEmail, [Validators.email, Validators.required]],
             invoiceEmail: [this.p24Registration.invoiceEmail, [Validators.email, Validators.required]],
             bankName: [this.p24Registration.bankName, Validators.required],
             bankAccount: [this.p24Registration.bankAccount, Validators.required],
             servicesDescription: [this.p24Registration.servicesDescription, Validators.required],
             bdPhone: [this.p24Registration.bdPhone, [Validators.required, mobilePhoneNumberValidator]],
             technicalPersonName: [this.p24Registration.technicalPersonName, Validators.required],
             technicalPersonEmail: [this.p24Registration.technicalPersonEmail, [Validators.email, Validators.required]],
             technicalPersonPhone: [this.p24Registration.technicalPersonPhone, [Validators.required, mobilePhoneNumberValidator]],
             contactPersonName: [this.p24Registration.contactPersonName, Validators.required],
             contactPersonEmail: [this.p24Registration.contactPersonEmail, [Validators.email, Validators.required]],
             contactPersonPhone: [this.p24Registration.contactPersonPhone, [Validators.required, mobilePhoneNumberValidator]],
             bdPostalCode: [this.p24Registration.bdPostalCode, Validators.required],
             bdCity: [this.p24Registration.bdCity, Validators.required],
             bdStreetWithNumber: [this.p24Registration.bdStreetWithNumber, Validators.required],
             correspondencePostalCode: [this.p24Registration.correspondencePostalCode, Validators.required],
             correspondenceCity: [this.p24Registration.correspondenceCity, Validators.required],
             correspondenceStreetWithNumber: [this.p24Registration.correspondenceStreetWithNumber, Validators.required],
             taxId: [this.p24Registration.taxId, Validators.required],
             regon: [this.p24Registration.regon, Validators.required],
             krs: [this.p24Registration.krs, Validators.required],
           });
           this.appStateService.updateIsBusySubject(false);
         } else {
           this.formGroup = this.formBuilder.group({
             bdName: [this.p24Registration.bdName, Validators.required],
             bdEmail: [this.p24Registration.bdEmail, [Validators.email, Validators.required]],
             invoiceEmail: [this.p24Registration.invoiceEmail, [Validators.email, Validators.required]],
             bankName: [this.p24Registration.bankName, Validators.required],
             bankAccount: [this.p24Registration.bankAccount, Validators.required],
             servicesDescription: [this.p24Registration.servicesDescription, Validators.required],
             bdPhone: [this.p24Registration.bdPhone, [Validators.required, mobilePhoneNumberValidator]],
             technicalPersonName: [this.p24Registration.technicalPersonName, Validators.required],
             technicalPersonEmail: [this.p24Registration.technicalPersonEmail, [Validators.email, Validators.required]],
             technicalPersonPhone: [this.p24Registration.technicalPersonPhone, [Validators.required, mobilePhoneNumberValidator]],
             contactPersonName: [this.p24Registration.contactPersonName, Validators.required],
             contactPersonEmail: [this.p24Registration.contactPersonEmail, [Validators.email, Validators.required]],
             contactPersonPhone: [this.p24Registration.contactPersonPhone, [Validators.required, mobilePhoneNumberValidator]],
             bdPostalCode: [this.p24Registration.bdPostalCode, Validators.required],
             bdCity: [this.p24Registration.bdCity, Validators.required],
             bdStreetWithNumber: [this.p24Registration.bdStreetWithNumber, Validators.required],
             correspondencePostalCode: [this.p24Registration.correspondencePostalCode, Validators.required],
             correspondenceCity: [this.p24Registration.correspondenceCity, Validators.required],
             correspondenceStreetWithNumber: [this.p24Registration.correspondenceStreetWithNumber, Validators.required],
             taxId: [this.p24Registration.taxId, Validators.required],
             regon: [this.p24Registration.regon, Validators.required],
           });
         }
       }
     }
    this.appStateService.updateIsBusySubject(false);
  }

  ngOnDestroy() {
    if(this.isBusySub){this.isBusySub.unsubscribe();}
    if(this.p24RegistrationDataSub){this.p24RegistrationDataSub.unsubscribe();}
  }

  onAction() {
    if(this.formGroup.valid && !this.p24Registration.uuid){
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz dodać dane rozliczeniowe?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        let bd: P24RegistrationData = this.commonUtils.formGroupValuesToObject<P24RegistrationData>(new P24RegistrationData(), this.formGroup);
        bd.businessType = this.businessType;
        this.appStateService.updateIsBusySubject(true);
        this.p24RegistrationDataService.addp24RegistrationData(bd,this.vetclicnicUUID).subscribe(e=>{
          if (e){
            this.p24Registration= e;
            this.p24RegistrationDataEventEmitter.emit(e);
            this.appStateService.updateIsBusySubject(false);
          }
        })
      }, () => {
      });
    } else{
      this.commonUtils.presentAlertToast('Uzupełnij poprawnie formularz')
    }

  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
      this.hasUnsavedChanges = true;
    }
  }

  onCancelAction() {
    if(this.hasUnsavedChanges){
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz anulować dodawanie danych rozliczeniowych?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.cancelEditp24Registration.emit(true);
      }, () => {
      });
    } else {
      this.cancelEditp24Registration.emit(true);
    }
  }

  isFormFieldInvalid(formGroup: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(formGroup, fieldName, validationType);
  }

  onSelectBusinessType($event) {
    this.appStateService.updateIsBusySubject(true);
    this.businessType = $event.detail.value as number;
    if(this.businessType == 1){
      this.formGroup= this.formBuilder.group({
        bdName: ['', Validators.required],
        bdEmail: ['', [Validators.email, Validators.required]],
        invoiceEmail: ['', [Validators.email, Validators.required]],
        bankName: ['', Validators.required],
        bankAccount: ['', Validators.required],
        servicesDescription: ['', Validators.required],
        bdPhone: ['', [Validators.required, mobilePhoneNumberValidator]],
        technicalPersonName: ['',  Validators.required],
        technicalPersonEmail: ['',[Validators.email,Validators.required]],
        technicalPersonPhone: ['',  [Validators.required, mobilePhoneNumberValidator]],
        contactPersonName: ['', Validators.required],
        contactPersonEmail: ['', [Validators.email, Validators.required]],
        contactPersonPhone: ['',  [Validators.required, mobilePhoneNumberValidator]],
        bdPostalCode: ['', Validators.required],
        bdCity: ['', Validators.required],
        bdStreetWithNumber: ['', Validators.required],
        correspondencePostalCode: ['', Validators.required],
        correspondenceCity: ['', Validators.required],
        correspondenceStreetWithNumber: ['', Validators.required],
        personalId: ['', Validators.required],
      });
      this.appStateService.updateIsBusySubject(false);
    }else{
      if(this.businessType>3){
        this.formGroup= this.formBuilder.group({
          bdName: ['', Validators.required],
          bdEmail: ['', [Validators.email, Validators.required]],
          invoiceEmail: ['', [Validators.email, Validators.required]],
          bankName: ['', Validators.required],
          bankAccount: ['', Validators.required],
          servicesDescription: ['', Validators.required],
          bdPhone: ['', [Validators.required, mobilePhoneNumberValidator]],
          technicalPersonName: ['',  Validators.required],
          technicalPersonEmail: ['',[Validators.email,Validators.required]],
          technicalPersonPhone: ['',  [Validators.required, mobilePhoneNumberValidator]],
          contactPersonName: ['', Validators.required],
          contactPersonEmail: ['', [Validators.email, Validators.required]],
          contactPersonPhone: ['',  [Validators.required, mobilePhoneNumberValidator]],
          bdPostalCode: ['', Validators.required],
          bdCity: ['', Validators.required],
          bdStreetWithNumber: ['', Validators.required],
          correspondencePostalCode: ['', Validators.required],
          correspondenceCity: ['', Validators.required],
          correspondenceStreetWithNumber: ['', Validators.required],
          taxId: ['', Validators.required],
          regon: ['', Validators.required],
          krs: ['', Validators.required],
        });
        this.appStateService.updateIsBusySubject(false);
      }else{
        this.formGroup= this.formBuilder.group({
          bdName: ['', Validators.required],
          bdEmail: ['', [Validators.email, Validators.required]],
          invoiceEmail: ['', [Validators.email, Validators.required]],
          bankName: ['', Validators.required],
          bankAccount: ['', Validators.required],
          servicesDescription: ['', Validators.required],
          bdPhone: ['', [Validators.required, mobilePhoneNumberValidator]],
          technicalPersonName: ['',  Validators.required],
          technicalPersonEmail: ['',[Validators.email,Validators.required]],
          technicalPersonPhone: ['',  [Validators.required, mobilePhoneNumberValidator]],
          contactPersonName: ['', Validators.required],
          contactPersonEmail: ['', [Validators.email, Validators.required]],
          contactPersonPhone: ['',  [Validators.required, mobilePhoneNumberValidator]],
          bdPostalCode: ['', Validators.required],
          bdCity: ['', Validators.required],
          bdStreetWithNumber: ['', Validators.required],
          correspondencePostalCode: ['', Validators.required],
          correspondenceCity: ['', Validators.required],
          correspondenceStreetWithNumber: ['', Validators.required],
          taxId: ['', Validators.required],
          regon: ['', Validators.required],
        });
        this.appStateService.updateIsBusySubject(false);
      }
    }
  this.markUnsavedChanges();
  }
}
